<h1 class="center">Gestion linge d'hébergement</h1>
<nav>
	<a class="tabs-orders" [ngClass]="isSelected ? 'tabs-orders-selected' : ''" routerLinkActive="active-link"
		(click)="reloadData('future')">Livraisons à venir</a>
	<a class="tabs-orders" [ngClass]="!isSelected ? 'tabs-orders-selected' : ''" routerLinkActive="active-link"
		(click)="reloadData('past')">Livraisons reçues</a>
</nav>
<div class="flex justify-center">
	<div class="clamp-commande">
		<div class="mat-tree-table">
			<div class="header">
				<div>Date de livraison</div>
				<div class="icon-custom">Statut
					<mat-icon (click)="help()" class="icon-click">help</mat-icon>
				</div>
				<div [ngClass]="'list-actions-' + (!isSelected ? '2' : '3')"></div>
			</div>
			<mat-tree [dataSource]="ELEMENT_DATA" [treeControl]="treeControl" class="example-tree">
				<mat-nested-tree-node *matTreeNodeDef="let node; when: hasChildren" class="commande">
					<div class="mat-tree-node">
						<button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.id">
							<mat-icon>
								{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
							</mat-icon>
						</button>
						<div class="node-title">{{ node.date_livraison | date: 'EEEE': 'fr' | titlecase }} -
							{{ node.date_livraison | date: 'dd/MM/yyyy': 'fr'}}
						</div>
						<div>
							<span [ngClass]="'state-circle ' + 'state-circle-' + node.statut.code"></span>
							{{ node.statut.libelle }}
						</div>
						<div [ngClass]="'list-actions-' + (!isSelected ? '2' : '3')">
							<mat-icon (click)="getCommandeDetails(node)"
								matTooltip="Voir plus">visibility</mat-icon>
							<a *ngIf="isEditable(node)" class="commande-list-button" routerLink="../edit-commande"
								[queryParams]="{ id: node.id }">
								<mat-icon matTooltip="Modifier">create</mat-icon>
							</a>
							<mat-icon *ngIf="isPrintable(node)" (click)="export(node.id)"
								matTooltip="Exporter">picture_as_pdf</mat-icon>
							<mat-icon *ngIf="isDispatchable(node)" (click)="sendCommande(node.id)"
								hideIfNot="!ROLE_HEBERGEMENT_LINGERE" matTooltip="Transmettre">send</mat-icon>
						</div>
					</div>
					<ul *ngIf="treeControl.isExpanded(node)">
						<div class="node">
							<ng-container matTreeNodeOutlet></ng-container>
						</div>
					</ul>
				</mat-nested-tree-node>
				<mat-nested-tree-node *matTreeNodeDef="let node; when: isCommande" class="commande">
					<div class="mat-tree-node">
						<button mat-icon-button disabled></button>
						<div class="node-title">{{ node.date_livraison | date: 'EEEE': 'fr' | titlecase }} -
							{{ node.date_livraison | date: 'dd/MM/yyyy': 'fr'}}
						</div>
						<div>
							<span [ngClass]="'state-circle ' + 'state-circle-' + node.statut.code"></span>
							{{ node.statut.libelle }}
						</div>
						<div [ngClass]="'list-actions-' + (!isSelected ? '2' : '3')">
							<mat-icon (click)="getCommandeDetails(node)"
								matTooltip="Voir plus">visibility</mat-icon>
							<a *ngIf="isEditable(node)" routerLink="../edit" [queryParams]="{ id: node.id }">
								<mat-icon matTooltip="Modifier">create</mat-icon>
							</a>
							<mat-icon *ngIf="node.can_edit_send" (click)="editSendOrder(node)"
								matTooltip="Modifier">create</mat-icon>
							<mat-icon *ngIf="isPrintable(node)" (click)="export(node.id)"
								matTooltip="Exporter">picture_as_pdf</mat-icon>
							<mat-icon *ngIf="isDispatchable(node)" (click)="sendCommande(node.id)"
								matTooltip="Transmettre">send</mat-icon>
						</div>
					</div>
					<ul *ngIf="treeControl.isExpanded(node)">
						<div class="node">
							<ng-container matTreeNodeOutlet></ng-container>
						</div>
					</ul>
				</mat-nested-tree-node>
				<mat-nested-tree-node *matTreeNodeDef="let node" class="lingerie">
					<li>
						<div class="lines-tree"></div>
						<div class="mat-tree-node">
							<div>
								{{node.lingerie?.libelle}}
							</div>
							<div class="node-title">{{node.date_modification == NULL ? "": "Modifié le
								"}}{{node.date_modification | date: 'dd/MM/yyyy': 'fr'}}
							</div>
							<div>
								<span [ngClass]="'state-circle ' + 'state-circle-' + node.statut.code"></span>
								{{ node.statut.libelle }}
							</div>
							<div [ngClass]="'list-actions-' + (!isSelected ? '2' : '3')">
								<mat-icon (click)="getInventaireDetails(node)"
									[matTooltip]="disabledVoir(node) ? '' : 'Voir plus'"
									[ngClass]="disabledVoir(node) ? 'disabled' : ''">visibility</mat-icon>
								<a *ngIf="isEditableInventaire(node)" routerLink="../edit-inventaire"
									[queryParams]="{ id: node.id }">
									<mat-icon matTooltip="Modifier">create</mat-icon>
								</a>
							</div>
						</div>
					</li>
				</mat-nested-tree-node>
			</mat-tree>
		</div>
		<div [hidden]="ELEMENT_DATA.data.length == 0">
			<mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
		</div>
	</div>
</div>

<mat-sidenav-container class="sidenav-container">
	<mat-sidenav class="sidenav-content" #sidebar [opened]="isSideBarOpen" (closed)="onSidebarClose()" position="end">
		<h3 class="sidenav-content-title">
			Liste des articles {{isSelected ? "à livrer le" : "commandés pour le"}} {{ dateLivraison | date: 'EEEE':
			'fr' }} {{ dateLivraison | date: 'dd/MM/yyyy': 'fr'}} :
		</h3>
		<div class="flex items-center flex-col">
			<table class="styled-table">
				<thead>
					<tr>
						<th>Article</th>
						<th *ngIf="!hasInventaires">Quantité *</th>
						<th *ngIf="hasInventaires">Pré-commande</th>
						<th *ngIf="hasInventaires">Commandé *</th>
						<th *ngIf="delivered()">Quantité livrée</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let data of sideBarData">
						<td>{{ data.article.designation }}</td>
						<td *ngIf="!hasInventaires">{{ data.quantite }}</td>
						<td *ngIf="hasInventaires">{{ data.preCommande }}</td>
						<td *ngIf="hasInventaires">{{ data.quantite }}</td>
						<td *ngIf="delivered()">{{ data.qte_livree }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="commentaire">* Les quantités livrées pourront être ajustées au plus près des quantités commandées,
			au moment de la préparation, pour garantir une livraison dans les meilleurs délais.</div>
	</mat-sidenav>
</mat-sidenav-container>

<mat-sidenav-container class="sidenav-container">
	<mat-sidenav class="sidenav-content" #sidebarInventaire [opened]="isSideBarInventaireOpen"
		(closed)="onSidebarInventaireClose()" position="end">
		<h3 class="sidenav-content-title">
			Liste des articles {{isSelected ? "à livrer le" : "commandés pour le"}} {{ dateLivraison | date: 'EEEE':
			'fr' }} {{ dateLivraison | date: 'dd/MM/yyyy': 'fr'}} :
		</h3>
		<h3 class="sidenav-subtitle">
			Lingerie '{{ sideBarInventaireData?.lingerie?.libelle }}'
		</h3>
		<div class="flex items-center flex-col">
			<table class="styled-table">
				<thead>
					<tr>
						<th>Article</th>
						<th *ngIf="enabledCoeff">Quantité max</th>
						<th *ngIf="!enabledCoeff">Dotation</th>
						<th>Restant</th>
						<th>Pré-commande</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let data of sideBarInventaireData?.inventaire_lignes">
						<td>{{ data.article.designation }}</td>
						<td>{{ data.dotation }}</td>
						<td>{{ data.restant }}</td>
						<td>{{ data.qte_commande }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</mat-sidenav>
</mat-sidenav-container>